import React, { useState } from 'react';
import { HelpCircleIcon, MessageSquareIcon, MailIcon, PhoneIcon, ChevronDownIcon, ExternalLinkIcon } from '../components/Icons';
import './HelpSupport.css';

const FAQ_DATA = [
  {
    question: "How do I issue a guest pass?",
    answer: "To issue a guest pass, navigate to the 'Events' section, select your event, and click on 'Issue Pass'. You will need to provide the guest's basic details and contact information. Once issued, the guest will receive an email with their unique QR code."
  },
  {
    question: "How can I approve a venue request?",
    answer: "Venue requests can be approved by users with AO or IQAC administrative roles. Go to the 'Approvals' section, review the pending requests, and click 'Approve' or 'Reject' as appropriate. The requester will be notified automatically."
  },
  {
    question: "What should I do if a QR code doesn't scan?",
    answer: "If a QR code fails to scan, ensure the screen brightness is high and the code is clearly visible. If it still fails, you can manually enter the 4-digit 'Entry Code' shown on the pass into the security portal's search field."
  },
  {
    question: "How do I resolve an escalation?",
    answer: "Escalations appear in the 'Escalations' section when a request needs administrative attention. Open the escalation chat to discuss details with the faculty member. Once resolved (e.g., event approved), the system will automatically close the chat."
  },
  {
    question: "Can I download guest lists for my event?",
    answer: "Yes, you can download guest lists from the 'Events' page. Open your event details and look for the 'Download List' option. This will provide a CSV or PDF file of all issued passes."
  }
];

export default function HelpSupport() {
  const [openFaq, setOpenFaq] = useState(null);

  const toggleFaq = (index) => {
    setOpenFaq(openFaq === index ? null : index);
  };

  return (
    <div className="page-shell">
      <div className="page-header">
        <div>
          <div className="page-title">Help & Support</div>
          <div className="page-subtitle">Get assistance and find answers to common questions</div>
        </div>
      </div>

      <div className="page-body support-layout">
        <div className="support-main">
          {/* FAQ Section */}
          <section className="card faq-section">
            <div className="section-header">
              <HelpCircleIcon />
              <h2>Frequently Asked Questions</h2>
            </div>
            <div className="faq-list">
              {FAQ_DATA.map((faq, index) => (
                <div key={index} className={`faq-item ${openFaq === index ? 'active' : ''}`}>
                  <button className="faq-question" onClick={() => toggleFaq(index)}>
                    <span>{faq.question}</span>
                    <ChevronDownIcon />
                  </button>
                  <div className="faq-answer">
                    <p>{faq.answer}</p>
                  </div>
                </div>
              ))}
            </div>
          </section>

          {/* Contact Section */}
          <section className="support-grid">
            <div className="card contact-card">
              <div className="contact-icon email">
                <MailIcon />
              </div>
              <h3>Email Support</h3>
              <p>For technical issues or detailed inquiries, reach out to our IT helpdesk.</p>
              <a href="mailto:support@krmu.edu.in" className="btn btn-navy">support@krmu.edu.in</a>
            </div>

            <div className="card contact-card">
              <div className="contact-icon phone">
                <PhoneIcon />
              </div>
              <h3>Emergency Contact</h3>
              <p>For urgent gate access issues, contact the campus security supervisor.</p>
              <a href="tel:+911234567890" className="btn btn-ghost">+91 123 456 7890</a>
            </div>
          </section>
        </div>

        <aside className="support-sidebar">
          <div className="card sidebar-cta">
            <MessageSquareIcon />
            <h3>Need Live Help?</h3>
            <p>Our administrators are available during university working hours (9 AM - 5 PM).</p>
            <button className="btn btn-primary btn-block" disabled>Start Chat (Coming Soon)</button>
          </div>

          <div className="card resources-card">
            <h3>Quick Resources</h3>
            <ul className="resource-links">
              <li>
                <a href="#">
                  <span>User Manual</span>
                  <ExternalLinkIcon />
                </a>
              </li>
              <li>
                <a href="#">
                  <span>Privacy Policy</span>
                  <ExternalLinkIcon />
                </a>
              </li>
              <li>
                <a href="#">
                  <span>Terms of Service</span>
                  <ExternalLinkIcon />
                </a>
              </li>
            </ul>
          </div>
        </aside>
      </div>
    </div>
  );
}
